export default "__VITE_ASSET__DinF5Wvu__"